import type { UIFacet } from 'src/components/types/UIFacet';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const adaptFacetToUIFacet = (facet: Facet): UIFacet => {
  return {
    key: facet.key,
    options: facet.options.map((option) => {
      return {
        active: option.active,
        count: option.count,
        ...(option.pseudoActive ? { pseudoActive: true } : {}),
        title: option.title,
        value: option.value,
        custom: option.custom,
      };
    }),
    title: facet.title || '',
    type: facet.type,
  };
};
